'use client';

import { DailyRecommendationsPanelView } from '@slims/ui/organisms';
import { useDailyRecommendations } from '@/hooks/use-daily-recommendations';

/**
 * Il piano giornaliero calcolato sui dati (INB-355): per ogni socio, a che ora
 * conviene far partire i carichi differibili e quanta energia condivisa ne viene. Un socio riceve
 * dall'API solo il proprio piano; l'amministratore tutti i soci.
 */
export function DailyRecommendations({ orgId, compact = false }: { orgId: string; compact?: boolean }) {
	const plan = useDailyRecommendations(orgId);
	return (
		<DailyRecommendationsPanelView
			available={plan.available}
			date={plan.date}
			horizonDays={plan.horizonDays}
			members={plan.members}
			totals={plan.totals}
			loading={plan.isLoading}
			reason={plan.reason}
			compact={compact}
		/>
	);
}
